import HttpClient from '@/libs/http';
// import moxios from 'moxios';

const $http = new HttpClient(window.appConfig.API_AUTH_BASE_URL);

const AuthService = {
  setJWTToken(jwt) {
    $http.setJWTToken(jwt);
  },
  removeJWTToken() {
    $http.removeJWTToken();
  },
  login(tenantId, email, password, cb) {
    $http
      .sendRequest('post', process.env.API_LOGIN_URL, {
        tenant_id: tenantId,
        email,
        password,
      }, null, cb);
  },
  logout(token, cb) {
    // window.localStorage.removeItem('vuex');
    $http
      .sendRequest('delete', `/auth-token/${token}`,
        null, null, cb);
  },
  heartbeat(token, cb) {
    $http
      .sendRequest('put', `/auth-token/${token}`, {
        active: true,
      }, null, cb);
  },
  checkSession(token, cb) {
    /* moxios.install($http.getInstance());
    setTimeout(() => {
      $http
        .sendRequest('get', `/auth-token/${token}/verification`,
          null, null, cb);
      moxios.wait(() => {
        const request = moxios.requests.mostRecent();
        request.respondWith({
          status: 403,
          response: {
            auth_code: 4031,
          },
        }).then(() => {
          moxios.uninstall($http.getInstance());
        });
      });
    }, 5000); */
    $http
      .sendRequest('get', `/auth-token/${token}/verification`,
        null, null, cb);
  },
  resetPassword(tenantId, email, cb) {
    // $http
    //   .sendRequest('post', '/reset-pwd-token', {
    //     tenant_id: tenantId,
    //     email,
    //   }, null, cb);
    $http
      .sendRequest('post', '/temporary-pwd', {
        tenant_id: tenantId,
        email,
      }, null, cb);
  },
  changePassword(force, token, password, cb) {
    let endpoint = '/pwd';
    if (force) {
      endpoint += `?auth_token_str=${token}`;
    } else {
      endpoint += `?reset_pwd_token=${token}`;
    }
    $http
      .sendRequest('put', endpoint, {
        new_pwd: password,
      }, null, cb);
  },
};

export default AuthService;



// WEBPACK FOOTER //
// ./src/services/auth.js